export default __webpack_public_path__ + "guy-holding-div-arms.6aa037.svg";